import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

import teaser from "./images/teaser-2.png";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import MyCarousel from "./Carousel.js";

const Abstract = ({ mobile }) => (
  <div>
    <MyCarousel mobile={mobile} />
    <p>
      <b>TL;DR</b>: Based on a fixed stable diffusion model, we disentangle target attributes 
      from a single training image. The learned parameters can then be applied to unseen images 
      and achieve same edits.
    </p>
    <br></br>
    <Header as="h2" textAlign="center" style={subsection_style}>
      Abstract
    </Header>
    <p>
    Generative models have been widely studied in computer vision. Recently, diffusion models have drawn 
    substantial attention due to the high quality of their generated images. A key desired property of image 
    generative models is the ability to disentangle different attributes, which should enable modification towards 
    a style without changing the semantic content, and the modification parameters should generalize to different 
    images. Previous studies have found that generative adversarial networks (GANs) are inherently endowed with such 
    disentanglement capability, so they can perform disentangled image editing without re-training or fine-tuning 
    the network. In this work, we explore whether diffusion models are also inherently equipped with such a capability. 
    Our finding is that for stable diffusion models, by partially changing the input text embedding from a neutral 
    description (e.g., "a photo of person") to one with style (e.g., "a photo of person with smile") while fixing 
    all the Gaussian random noises introduced during the denoising process, the generated images can be modified towards 
    the target style without changing the semantic content. Based on this finding, we further propose a simple, 
    light-weight image editing algorithm where the mixing weights of the two text embeddings are optimized for style 
    matching and content preservation. This entire process only involves optimizing over around 50 parameters and 
    does not fine-tune the diffusion model itself. Experiments show that the proposed method can modify a wide range 
    of attributes, with the performance outperforming diffusion-model-based image-editing algorithms that require 
    fine-tuning. The optimized weights generalize well to different images.
    </p>
  </div>
);

export default Abstract;
